import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import api from '../api';

function AdminPanel() {
  const { user } = useSelector((state) => state.auth);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('users');
  
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await api.get('/admin/users');
      setUsers(response.data.data.users);
    } catch (error) {
      console.error('Failed to fetch users:', error);
    }
    setLoading(false);
  };
  
  const handleRoleChange = async (userId, newRole) => {
    try {
      await api.put(`/admin/users/${userId}/role`, { role: newRole });
      fetchUsers();
    } catch (error) {
      console.error('Failed to update role:', error);
    }
  };
  
  const handleUserStatus = async (userId, isActive) => {
    try {
      await api.put(`/admin/users/${userId}/status`, { isActive });
      fetchUsers();
    } catch (error) {
      console.error('Failed to update status:', error);
    }
  };
  
  return (
    <div className="admin-panel">
      <h1>Admin Panel</h1>
      <div className="admin-tabs">
        <button onClick={() => { setActiveTab('users'); fetchUsers(); }} className={activeTab === 'users' ? 'active' : ''}>
          Manage Users
        </button>
        <button onClick={() => setActiveTab('stats')} className={activeTab === 'stats' ? 'active' : ''}>
          Statistics
        </button>
      </div>
      
      {activeTab === 'users' && (
        <div className="users-table">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.userId}>
                    <td>{user.email}</td>
                    <td>
                      <select
                        value={user.role}
                        onChange={(e) => handleRoleChange(user.userId, e.target.value)}
                        disabled={user.role === 'superadmin'}
                      >
                        <option value="user">User</option>
                        <option value="moderator">Moderator</option>
                        <option value="admin">Admin</option>
                        <option value="superadmin">Super Admin</option>
                      </select>
                    </td>
                    <td>
                      <button onClick={() => handleUserStatus(user.userId, !user.isActive)}>
                        {user.isActive ? 'Ban' : 'Activate'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}

export default AdminPanel;